import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  states: [],
  courses: [],
  branches: [],
  gender: [{value:"female",label:"Female"},{value:"male",label:"Male"}],
  trainingQuestions: [],
  workexQuestions: [],
  projectQuestions: [],
  marksUnit: [],
  trainingTypes: [],
  liveTrainings: [],
  liveBatches: [],
  eventModes: [{value:"Online",label:"Online"},{value:"Offline",label:"Offline"}],
  eventPlatforms: [{value:"Google Meet",label:"Google Meet"},{value:"Zoom",label:"Zoom"},{value:"Discord",label:"Discord"}],
  sessionType:[{value:"event",label:"Event"},{value:"training",label:"Training"},{value:"internship",label:"Internship"}]
};

const masterSlice = createSlice({
  name: 'masters',
  initialState,
  reducers: {
    setBranches(state, action){
      state.branches = action.payload;
    },
    setCourses(state, action){
      state.courses = action.payload;
    },
    setEventModes(state, action){
      state.eventModes = action.payload;
    },
    setEventPlatforms(state, action){
      state.eventPlatforms = action.payload;
    },
    setGender(state, action){
      state.gender = action.payload;
    },
    setLiveTrainings(state, action){
      state.liveTrainings = action.payload;
    },
    setLiveBatches(state, action){
      state.liveBatches = action.payload;
    },
    setMarksUnit(state, action){
      state.marksUnit = action.payload;
    },
    setProjectQuestions(state, action){
      state.projectQuestions = action.payload;
    },
    setSessionTypes(state,action){
      state.sessionType = action.payload;
    },
    setStates(state, action){
      state.states = action.payload;
    },
    setTrainingQuestions(state, action){
      state.trainingQuestions = action.payload;
    },
    setTrainingTypes(state, action){
      state.trainingTypes = action.payload;
    },
    setWorkexQuestions(state, action){
      state.workexQuestions = action.payload;
    }
  },
});

export const { setGender, setCourses, setBranches, setMarksUnit, setProjectQuestions, setStates, setTrainingQuestions, setTrainingTypes, setLiveTrainings,  setWorkexQuestions, setEventModes, setEventPlatforms, setSessionTypes, setLiveBatches } = masterSlice.actions;
const masterReducer = masterSlice.reducer;

export default masterReducer;
